import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ScreenerTemplateType } from 'features/screener/types';
import ListTableScreener from './ListTableScreener';
import ListScreener from './ListScreener';
import PresetScreener from './PresetScreener';

import valuationWidgetSlice, { effects, selectors } from '../slice';
import { DEFAULT_TYPE_PRESET, INITIAL_PAGE } from '../constants';

interface ScreenerContentTypes {
  isHumbergerScreener: boolean;
  isPresetScreener: boolean;
  handlePresetScreener: () => void;
  handleOffScreenerAndHamburger: () => void;
  setScreenerTitle: (param: string) => void;
  maxAutocompleteHeight: string;
}

const ScreenerContent = ({
  isHumbergerScreener,
  isPresetScreener,
  handlePresetScreener,
  handleOffScreenerAndHamburger,
  setScreenerTitle,
  maxAutocompleteHeight,
}: ScreenerContentTypes) => {
  const dispatch = useDispatch();
  const state = useSelector(selectors);
  const {
    getScreenerCustom,
    getScreenerMetrics,
    getLoadPresetScreener,
    currentScreenerData,
  } = state;

  const { data: dataScreenerCustom } = getScreenerCustom;

  const { data: dataPresetScreener } = getScreenerMetrics;

  const handleOnClickDetailPreset = (
    presetId: number,
    type: ScreenerTemplateType = DEFAULT_TYPE_PRESET,
  ) => {
    // TODO: Remove this lines after layout feature has been implemented

    dispatch(
      // @ts-ignore
      valuationWidgetSlice.actions.setCurrentScreenerData({
        page: INITIAL_PAGE,
        presetId,
        type,
      }),
    );
    // dispatch load with presetId
    dispatch(effects.getLoadPresetScreener({ presetId, type }));

    handleOffScreenerAndHamburger();
  };

  // didmount
  useEffect(() => {
    const { presetId } = currentScreenerData;
    const type = currentScreenerData.type || DEFAULT_TYPE_PRESET;

    // HIT API getScreenerCustom
    dispatch(effects.getScreenerCustom());

    // HIT API getScreenerMetrics
    dispatch(effects.getScreenerMetrics());

    // HIT API getLoadPresetScreener
    dispatch(effects.getLoadPresetScreener({ presetId, type }));

    // TODO: Remove this lines after layout feature has been implemented
    return () => {
      dispatch(
        // @ts-ignore
        valuationWidgetSlice.actions.setCurrentScreenerData({
          isDataLoaded: false,
          shouldUpdate: true,
        }),
      );
    };
  }, [dispatch]);

  // to set screener title
  useEffect(() => {
    const { isLoading, data } = getLoadPresetScreener;
    const { screen_name: screenerName } = data;

    if (!isLoading) {
      setScreenerTitle(screenerName);
    }
  }, [getLoadPresetScreener, setScreenerTitle]);

  // render ListScreener
  if (isHumbergerScreener) {
    return (
      <ListScreener
        dataScreenerCustom={dataScreenerCustom}
        handleOnClickDetailPreset={handleOnClickDetailPreset}
      />
    );
  }

  // render PresetScreener
  if (isPresetScreener) {
    return (
      <PresetScreener
        handlePresetScreener={handlePresetScreener}
        dataPresetScreener={dataPresetScreener}
        handleOnClickDetailPreset={handleOnClickDetailPreset}
        maxAutocompleteHeight={maxAutocompleteHeight}
      />
    );
  }
  return <ListTableScreener />;
};

export default ScreenerContent;
